module.exports = __webpack_public_path__ + "static/img/LMM-3.0-logo.cfbe086b.svg";